export const normalizeFinanceCurrency = (value, fallback = "TRY") => {
  const code = String(value || fallback).trim().toUpperCase();
  return code === "TL" ? "TRY" : code;
};

const marketEntry = (prices, key) => {
  const raw = prices?.[key];
  if (raw == null) return null;
  const price = Number(typeof raw === "object" ? (raw.price ?? raw.value ?? raw.rate) : raw);
  if (!Number.isFinite(price) || price <= 0) return null;
  return { price, currency: normalizeFinanceCurrency(typeof raw === "object" ? raw.currency : "TRY") };
};

export const financeTryRate = (prices, currency) => {
  const code = normalizeFinanceCurrency(currency);
  if (code === "TRY") return 1;
  const direct = marketEntry(prices, `Döviz:${code}`)?.price;
  if (direct) return direct;
  if (code === "USD") {
    const gramTry = marketEntry(prices, "Altın:Gram")?.price;
    const gramUsd = marketEntry(prices, "Gold:Gram")?.price;
    if (gramTry && gramUsd) return gramTry / gramUsd;
  }
  return null;
};

export const convertFinanceCurrency = (amount, fromCurrency, toCurrency, prices) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;
  const from = normalizeFinanceCurrency(fromCurrency, toCurrency);
  const to = normalizeFinanceCurrency(toCurrency);
  if (from === to) return value;
  const fromTry = financeTryRate(prices, from);
  const toTry = financeTryRate(prices, to);
  if (!fromTry || !toTry) return null;
  return (value * fromTry) / toTry;
};

export const financeAmountInBase = (item, baseCurrency, prices) => convertFinanceCurrency(
  item?.tutar ?? item?.amount ?? 0,
  item?.paraBirimi || item?.currency || baseCurrency,
  baseCurrency,
  prices
);
